module.exports = __webpack_public_path__ + "static/media/wd3.c6e92414.jpeg";